import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import { ThemePalette } from 'mui.theme';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

interface ReloadDialogProps {
  open: boolean;
  title?: string;
  message?: string;
  buttonText?: string;
}

export const ReloadDialog: React.FC<ReloadDialogProps> = ({
  open,
  title = 'App Reload required',
  message = 'Action completed successfully.',
  buttonText = 'OK',
}) => {
  const palette = clientThemePalette[CLIENT_THEME].light;
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      onClose={() => {}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      BackdropProps={{
        style: {
          backdropFilter: 'blur(8px)',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
      }}
      sx={{
        '& .MuiDialog-paper': {
          backgroundColor: palette.boxBackground,
          color: ThemePalette.typography.wheat,
        },
      }}
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          sx={{
            color: ThemePalette.typography.wheat,
          }}
        >
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            window.location.reload();
          }}
          sx={{
            color: ThemePalette.typography.wheat,
            backgroundColor: '#1049E4',
            paddingLeft: '15px',
            paddingRight: '15px',
          }}
        >
          {buttonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReloadDialog;
